export default __webpack_public_path__ + "static/media/sneakers.78f84318.png";